import { classNames } from "primereact/utils";
import styles from "./SelectField.module.scss";
import { RenderWhen } from "../../../../infrastructure/components/RenderWhen";
import { useSelectField } from "./hooks/useSelectField";
import { AppMultiSelectDropDown } from "./abstract/AppMultiselectDropDown";
import { AppTooltip } from "../../../tooltip/AppTooltip";

interface IMultiSelectField<TOption> {
  options: TOption[];
  hasGroupedOptions?: boolean;
  disabled?: boolean;
  className?: string;
  filter?: boolean;
  filterBy?: string;
  includeId?: boolean;
  value?: number[];
  editable?: boolean;
  width?: string;
  defaultValue?: number[];
  label?: string;
  required?: boolean;
  emptyMessage?: string;
  onChange?: (value: number[] | null) => void;
}

export const MultiSelectField = <TOption,>({
  options,
  hasGroupedOptions,
  disabled,
  className,
  filter,
  filterBy,
  includeId,
  value,
  editable = false,
  width = "135px",
  defaultValue,
  label,
  required,
  emptyMessage,
  onChange,
}: IMultiSelectField<TOption>) => {
  const { isFocused, onFocus, onBlur } = useSelectField();
  return (
    <div
      style={{ width: width }}
      className={classNames(styles.root, className)}
    >
      <RenderWhen condition={!!label}>
        <div
          className={classNames(styles.root_label, {
            [styles.root_label_interacted_with]: isFocused || value !== null,
          })}
        >
          {label}
          {required ? "*" : ""}
        </div>
      </RenderWhen>

      <AppMultiSelectDropDown
        options={options}
        disabled={disabled}
        filter={filter}
        filterBy={filterBy}
        includeId={includeId}
        editable={editable}
        hasGroupedOptions={hasGroupedOptions}
        value={value}
        className={styles.root_dropdown}
        defaultValue={defaultValue}
        emptyMessage={emptyMessage}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
      />
    </div>
  );
};
